var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"picture"},[_c('img',{attrs:{"src":_vm.getResult,"alt":"Foto"}})])}
var staticRenderFns = []

export { render, staticRenderFns }